import Image from 'next/image'

const TUTORIAL_LIST = [
  {
    image: './images/payment-ver2/tutorial-1.png',
    title: 'Bước 1',
    description: <span>Bấm vào nút <span className="font-semibold">Thanh toán</span> trên màn hình quản lý của phần mềm KiotViet</span>,
  },
  {
    image: './images/payment-ver2/tutorial-2.png',
    title: 'Bước 2',
    description: <span>Chọn <span className="font-semibold">ngân hàng/ví</span> bạn muốn sử dụng và bấm <span
      className="font-semibold">&rdquo;Đăng ký&rdquo;</span></span>,
  },
  {
    image: './images/payment-ver2/tutorial-3.png',
    title: 'Bước 3',
    description: <span>Nhập thông tin tài khoản ngân hàng của bạn sau đấy xác thực để hoàn tất đăng ký</span>,
  },
]


export default function Tutorial() {
  return (
    <div
      id="huong-dan-kich-hoat"
      className="flex flex-col lg:gap-14 gap-8 xl:px-[83px] lg:px-12 md:px-8 px-[18px] lg:pt-20 lg:pb-12 pt-12 pb-4 ">
      <div
        className=" mx-auto font-bold lg:text-3xl text-2xl leading-9 text-brand-primary-850 text-center md:w-fit w-[394px]">
        Hướng dẫn kích hoạt Thông báo thanh toán QR
      </div>
      <div className="flex md:flex-row mx-auto flex-col lg:gap-6 gap-8 ">
        {TUTORIAL_LIST.map(tutorial => (
          <div
            key={tutorial.title}
            className="flex flex-col justify-center xl:w-[384px] lg:w-[378px] md:w-[224px] w-[384px] lg:gap-4 gap-3 p-6"
          >
            <div className="mx-auto relative lg:size-[200px] md:size-[160px] size-[200px]">
              <Image src={tutorial.image} alt={tutorial.title} fill={true} />
            </div>
            <div className="flex flex-col gap-2 text-center">
              <div className="text-brand-navy font-bold text-xl">{tutorial.title}</div>
              <div className="text-text-base font-normal text-base">{tutorial.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}